import { useState } from "react";
import {
  FaqSectionAnswer,
  FaqSectionAnswerInner,
  FaqSectionAnswerWrap,
  FaqSectionList,
  FaqSectionQuestionButton,
  FaqSectionQuestionLead,
  FaqSectionQuestionQ,
  FaqSectionQuestionText,
  FaqSectionQuestionToggle,
  FaqSectionRoot,
  FaqSectionTitle,
} from "../styles";

type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

const faqItems: FaqItem[] = [
  {
    id: "fee",
    question: "利用料金を教えてください",
    answer: "完全に無料でお使いいただけます。成約報酬等もございません。",
  },
  {
    id: "contact",
    question: "どのように連絡が来ますか？",
    answer:
      "入力いただいた情報をもとに、コンシェルジュからのみ連絡がいきます。不動産会社から一斉に連絡が来ることはありません。",
  },
  {
    id: "company",
    question: "運営会社は宅建業者ですか？",
    answer:
      "当社は宅地建物取引業者ではありません。\n売買契約の締結等は当事者間で行っていただきます。",
  },
];

export default function FaqSection() {
  const [openMap, setOpenMap] = useState<Record<string, boolean>>(
    faqItems.reduce((acc, item) => ({ ...acc, [item.id]: true }), {}),
  );

  const toggleItem = (id: string) => {
    setOpenMap((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <FaqSectionRoot>
      <FaqSectionTitle>よくある質問</FaqSectionTitle>

      <FaqSectionList>
        {faqItems.map((item) => {
          const isOpen = openMap[item.id];

          return (
            <article key={item.id}>
              <FaqSectionQuestionButton type="button" onClick={() => toggleItem(item.id)}>
                <FaqSectionQuestionLead>
                  <FaqSectionQuestionQ>Q</FaqSectionQuestionQ>
                  <FaqSectionQuestionText>{item.question}</FaqSectionQuestionText>
                </FaqSectionQuestionLead>
                <FaqSectionQuestionToggle>{isOpen ? "-" : "+"}</FaqSectionQuestionToggle>
              </FaqSectionQuestionButton>
              <FaqSectionAnswerWrap $open={isOpen}>
                <FaqSectionAnswerInner>
                  <FaqSectionAnswer>{item.answer}</FaqSectionAnswer>
                </FaqSectionAnswerInner>
              </FaqSectionAnswerWrap>
            </article>
          );
        })}
      </FaqSectionList>
    </FaqSectionRoot>
  );
}
